import { atom } from "jotai";
import { ICreateDesignRequest, IApplyPatternRequest, ICreateSampleRequest, ICreateHeaderRequest } from "../product";

export const processingQueueAtom = atom<IProcessingQueueItem[]>([]);
export const processingQueueLoadingAtom = atom<boolean>(false);

export interface IProcessingQueueItem {
    id: number;
    created_at: string;
    passthrough_data: ICreateDesignRequest | IApplyPatternRequest | ICreateSampleRequest | ICreateHeaderRequest;
    category: 'MOCKUP_UPLOAD' | 'SAMPLE_CREATION' | 'PRODUCT_UPLOAD' | 'HEADER_CREATION';
    status_message: string;
    status: 'unprocessed' | 'processing' | 'processed' | 'failed';
    brand_id: number;
}
